{
  "title": "随时随地 轻松阅报",
  "body": "订阅解锁电子报，便能在您喜爱的设备随心阅读新闻专题和深度评析。",
  "cta": "立即订阅",
  "backToPublicationLink": "暂不需要",
  "title2": "一元即购电子报，一日新闻随心读",
  "body2": "无合约，随时轻松解锁丰富资讯",
  "cta2": "立即购买 - $1/天",
  "backToPublicationLink2": "下次购买"
}
